import { render, staticRenderFns } from "./exchangePrizeFailure.vue?vue&type=template&id=6f749b1b&scoped=true&"
import script from "./exchangePrizeFailure.vue?vue&type=script&lang=js&"
export * from "./exchangePrizeFailure.vue?vue&type=script&lang=js&"
import style0 from "./exchangePrizeFailure.vue?vue&type=style&index=0&id=6f749b1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f749b1b",
  null
  
)

export default component.exports